<script setup lang="ts">
import { useRouter } from 'vue-router';
import { reactive } from 'vue'
import Overlay from '../Overlay.vue';
import PageTitle from '../controls/PageTitle.vue';
import AuthenticationApi from '../../sdk/AuthenticationApi';

const router = useRouter();
const authApi = new AuthenticationApi();

const data = reactive({ 
  email: '',
  recoveryInProgress: false,
  recoveryErrorOccurred: false,
  recoverySuccessful: false,
})

const sendRecoveryLinkClicked = async function() {
    if (!data.email) {
        data.recoveryErrorOccurred = true;
        return;
    }

    try {
        data.recoveryErrorOccurred = false;
        data.recoveryInProgress = true;
        
        await authApi.recoverPassword(data.email);
        
        data.recoveryInProgress = false;
        data.recoverySuccessful = true;
    }
    catch(error) {
        data.recoveryInProgress = false;
        data.recoveryErrorOccurred = true;
        return;
    }
}

const backToLoginClicked = async function() {
    router.push({ name: "Login" });
}

</script>

<template>
  <div class="form-container">

    <PageTitle text="Passwort zurücksetzen"></PageTitle>

    <div class="row">
      <div class="col-xs-12">
        <div class="box-row card cardshadow">
            <div v-if="!data.recoverySuccessful">
                <p style="margin-bottom: 2rem; color: #666;">
                    Geben Sie Ihre E-Mail-Adresse ein und wir senden Ihnen einen Link zum Zurücksetzen Ihres Passworts.
                </p>
                
                <input 
                    type="email" 
                    name="email" 
                    id="email" 
                    class="textbox-style" 
                    v-model="data.email" 
                    placeholder="E-Mail-Adresse"
                >

                <button 
                    type="submit" 
                    name="sendRecoveryLink" 
                    class="buttonstyle" 
                    style="margin-top:2rem; margin-bottom: 1rem;" 
                    @click="sendRecoveryLinkClicked"
                >
                    <span>Link senden</span>
                </button>
                
                <label v-if="data.recoveryErrorOccurred" class="label-style label-warning">
                    Ein Fehler ist aufgetreten. Bitte überprüfen Sie Ihre E-Mail-Adresse und versuchen Sie es erneut.
                </label>
            </div>

            <div v-else class="success-message">
                <div style="color: var(--main-color); font-size: 1.6rem; margin-bottom: 2rem;">
                    ✓ E-Mail gesendet!
                </div>
                <p style="margin-bottom: 2rem; color: #666;">
                    Wir haben Ihnen einen Link zum Zurücksetzen Ihres Passworts an <strong>{{ data.email }}</strong> gesendet. 
                    Bitte überprüfen Sie Ihr E-Mail-Postfach und folgen Sie den Anweisungen in der E-Mail.
                </p>
            </div>

            <div class="divider"></div>
            
            <button 
                type="submit" 
                name="backToLogin" 
                class="buttonstyle" 
                style="margin-top:2rem; margin-bottom: 1rem;" 
                @click="backToLoginClicked"
            >
                <span>Zurück zum Login</span>
            </button>
        </div>
      </div>
    </div>

    <Overlay v-model:isvisible="data.recoveryInProgress" :is-closable="false" height="80px" width="200px" rounded-corners="0.5rem">
        <div style="display: flex;justify-content: center;align-items: center;height: 100%;">
            <div style="color: gray;">Link wird gesendet...</div>
        </div>
    </Overlay>
  </div>
</template>

<style scoped>
.card {
  background-color: white;
  padding: 2rem
}

.divider {
  border-bottom: 1px solid lightgray;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.success-message {
  text-align: center;
}
</style>
